import type { TimeFrame } from 'components/AnimatedTimelineControl';
import type { TerrierTimeSlice } from '../vendor/terrier';

/**
 * Format a timestamp for display in the timeline.
 */
const formatTimestamp = (timestamp: Date): string =>
  timestamp.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

/**
 * Generate TimeFrame objects from actual manifest time slices.
 */
export const generateFramesFromSlices = (
  timeSlices: TerrierTimeSlice[],
): TimeFrame[] =>
  timeSlices.map((slice) => {
    const timestamp = new Date(slice.forecastEpoch * 1000);
    return {
      timestamp,
      label: formatTimestamp(timestamp),
    };
  });
